import { handleActions } from 'redux-actions-helpers';
import { change, toggle, closeSelect, resetSelect, changeDate } from './actions';
import config from 'config';

export const initialState = {
    logo: {
        value: config.selectLogo[0].text,
        show : false
    },
    line: {
        value: config.selectLine[0].text,
        show : false
    },
    period: {
        value: config.selectPeriod[0].text,
        show : false,
        date : null
    },
    special: {
        value: config.selectSpecial[0].text,
        show : false
    }
};

export default handleActions({
    [change]: (state, { id, value }) => {
        return {
            ...state,
            [id]: {
                ...state[id],
                value
            }
        }
    },
    [changeDate]: (state, { date }) => {
        return {
            ...state,
            period: {
                ...state.period,
                date
            }
        }
    },
    [toggle]: (state, { id }) => {
        const newState = { ...state };

        for(const key in newState) {
            if(key === id) {
                newState[key].show = !newState[key].show
            } else {
                newState[key].show = false
            }
        }

        return {
            ...state,
            ...newState
        }
    },
    [closeSelect]: (state) => {
        const newState = { ...state };

        for(const key in newState) { //eslint-disable-line guard-for-in
            newState[key].show = false
        }

        return {
            ...state,
            ...newState
        }
    },
    [resetSelect]: (state) => {
        return {
            ...state,
            period : initialState.period,
            special: initialState.special
        }
    }
}, { initialState });



// WEBPACK FOOTER //
// ./src/blocks/select/reducer.js